import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
} from '../../utils/redux';

export const consts = createReqConsts('board', 'reqNewChannel');
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'context_chat_rooms',
  type: 'post',
});

export default createReqReducer(consts);



// WEBPACK FOOTER //
// ./src/redux/board/reqNewChannel.js